import React from 'react';
import { CustomerCreateForm } from '../components/CustomerCreateForm';
import { FormPageLayout } from '../../../components/layout/FormPageLayout';

export function CustomerCreatePage() {
  return (
    <FormPageLayout
      title="New Customer"
      subtitle="Register a new customer or member. Fields marked with * are required for all customer types."
      backTo="/customers"
      variant="card"
    >
      <CustomerCreateForm />
    </FormPageLayout>
  );
}
